import PropTypes from 'prop-types';

import SummaryCheck from './SummaryCheck';

const CheckBillAddr = ({ t, useAsBilling, onChange, disabled }) => (
  <SummaryCheck
    t={t}
    id="addr-check"
    label={t('checkout:shippingAddress.useAsBilling')}
    checked={useAsBilling}
    onCheckedChange={() => onChange(!useAsBilling)}
    disabled={disabled}
  />
);

CheckBillAddr.propTypes = {
  t: PropTypes.func.isRequired,
  useAsBilling: PropTypes.bool,
  onChange: PropTypes.func
};

export default CheckBillAddr;
